module.exports = __webpack_public_path__ + "static/media/houdini.761ee368.png";